<div class="t-widget--noPadding">
  <header class="l-flex-column l-align-top summary-box-header">
    <h2 class="t-widgetTitle">
      {{ "translate.order.notes" | translate }}
    </h2>
    <hr />
  </header>
  <div class="chat-page">
    <div class="container clearfix t-widget">
      <div class="chat">
        <div class="chat-history note-history" id="notes">
          <ul>
            <li *ngFor="let note of order.notes" class="clearfix">
              <div class="chat-message-container my">
                <div class="msg-with-delete-container my">
                  <div class="message my" (click)="onNoteClicked(note)">
                    <span> {{ note.text }}</span>
                  </div>

                  <a
                    *ngIf="allowDelete && displayActionsBtn && note == curNote"
                    (click)="deleteNote(note)"
                  >
                    <img class="icon-action" src="assets\img\Delete.svg"
                  /></a>
                </div>

                <div class="message-data my">
                  <span
                    >{{ note.createUserDescr }} /
                    {{ note.timestamp | date : "HH:mm - dd.MM.yyyy" }}</span
                  >
                </div>
              </div>
            </li>
          </ul>
        </div>

        <div class="input-message clearfix">
          <button
            class="btn-emoji"
            id="emoji-trigger-notes"
            (click)="emojiPanelNotes.toggle($event)"
          >
            <i class="far fa-smile"></i>
          </button>

          <textarea
            dir="auto"
            name="message-to-send"
            [rows]="1"
            [(ngModel)]="newNote.text"
            [disabled]="sending"
            (keypress)="onKeyPress($event)"
            pTextarea
            [autoResize]="true"
          ></textarea>

          <button
            class="t-button--rounded"
            (click)="sendNote()"
            [disabled]="sending || !newNote.text"
          >
            <img class="icon-send-msg" src="assets\img\Send_Message.svg" />
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<p-popover #emojiPanelNotes [dismissable]="true" appendTo="body">
  <emoji-mart
    (emojiClick)="addEmoji($event, emojiPanelNotes)"
    emoji="point_up"
    [showPreview]="false"
  ></emoji-mart>
</p-popover>
